import React, { Component } from 'react';

// import Custom Componenets
import BootstrapTable from 'react-bootstrap-table-next';
import Modal from 'react-responsive-modal';
import { Button, Form, FormGroup, Label, Col } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';

// koneksi
import API_URL, { Post, Delete, Get, JENIS_DESA, } from '../../../function/Koneksi';

// css files
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Datetime from 'react-datetime';

import ReactSelect from 'react-select';

const frmDex = {
	uuid: '',
	jenis_barang_bangunan: null,
	tahun: new Date().getFullYear(),
	dibeli_sendiri: '0',
	pemerintah: '0',
	provinsi: '0',
	kab_kota: '0',
	sumbangan: '0',
	keadaan_baik_awal_tahun: '0',
	keadaan_rusak_awal_tahun: '0',
	penghapusan_rusak: '0',
	penghapusan_dijual: '0',
	penghapusan_disumbangkan: '0',
	tanggal_penghapusan: new Date(),
	keadaan_baik_akhir_tahun: '0',
	keadaan_rusak_akhir_tahun: '0',
	keterangan: '',
}

const dateFormat = require('dateformat');

class MenuA3 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: [],
			pagination: [],
			status: {
				form: false,
				btnForm: false,
				btnAksi: false
			},
			loading: false,
			loadingPreview: false,
			imagePreview: null,
			detailPreview: false,
			detailData: null,
			awal: '',
			sebelum: '',
			hal: [],
			setelah: '',
			akhir: '',
			dt: frmDex,
			judul: 'Tambah Inventaris ' + JENIS_DESA,
			textCari: '',
			alert: null,
			show: false,
			basicTitle: '',
			basicType: 'default',
			pesanAlert: '',
			editMode: false
		};
	}

	// ================== Sweet Alert ==================
	closeAlert = () => {
		this.setState({
			show: false
		});
	};

	hideAlert = () => {
		this.setState({
			alert: null
		});
	};

	// =================================================

	pagination = data => {
		// const data = this.state.pagination;
		//console.log(data);
		let awal = "";
		let hal = [];
		let sebelum = "";
		let setelah = "";
		let akhir = "";
		if (data.total > 0) {
			let start = 1;
			let end = 5;
			let n = 0;
			let p = 0;
			if (data.current_page <= 3) {
				start = 1;
				end = 5;
				if (data.last_page > data.current_page) {
					n = data.current_page + 1;
				}
			} else {
				p = data.current_page - 1;
				n = data.current_page + 1;
				start = data.current_page - 2;
				end = data.current_page + 2;
			}
			if (end >= data.last_page - 2) {
				p = data.current_page - 1;
				if (start >= 5) {
					start = data.last_page - 4;
				}
				end = data.last_page;
			}

			for (let i = start; i <= end; i++) {
				let warna = "primary-custom";
				if (i === data.current_page) {
					warna = "danger";
				}
				hal.push(
					<a
						onClick={() => this.fetch({ page: i })}
						className={
							"btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
						}
					>
						{i}
					</a>
				);
			}
			if (p > 0) {
				sebelum = (
					<a
						onClick={() => this.fetch({ page: p })}
						className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
					>
						{"<"}
					</a>
				);
			}
			if (n > 0) {
				setelah = (
					<a
						onClick={() => this.fetch({ page: n })}
						className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
					>
						{">"}
					</a>
				);
			}
			awal = (
				<a
					onClick={() => this.fetch({ page: 1 })}
					className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				>
					{"<<"}
				</a>
			);
			akhir = (
				<a
					onClick={() => this.fetch({ page: data.last_page })}
					className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				>
					{">>"}
				</a>
			);
		}
		this.setState({ awal, sebelum, hal, setelah, akhir });
	};

	fetch = (params = {}) => {
		this.setState({ loading: true })
		let link = "";
		if (params.page) {
			switch (params.page) {
				case ">>":
					link =
						"?page=" +
						Math.ceil(
							this.state.pagination.total / this.state.pagination.per_page
						);
					break;
				case ">":
					link = "?page=" + (parseInt(this.state.pagination.current_page) + 1);
					break;
				case "<":
					link = "?page=" + (parseInt(this.state.pagination.current_page) - 1);
					break;
				case "<<":
					link = "?page=1";
					break;
				default:
					link = "?page=" + params.page;
					break;
			}
		}

		// if (this.state.textCari === '') {
		// 	Get("inventaris-desa" + link, null, dtkat => {
		// 		// console.log(dtkat);

		// 		if (dtkat.results) {
		// 			this.setState({
		// 				data: dtkat.results.data,
		// 				pagination: dtkat.results,
		// 				loading: false
		// 			})
		// 			this.pagination(dtkat.results);
		// 		}

		// 	});
		// } else { // Jika pencarian
		Post("inventaris-desa" + link, null, {
			q: this.state.textCari
		}, dtkat => {
			if (dtkat.data.results) {
				console.log('masuk');
				this.setState({
					data: dtkat.data.results.data,
					pagination: dtkat.data.results,
					loading: false
				})
				this.pagination(dtkat.data.results);
			}

		});
		// }

	};

	// ================== simpan data ==================
	simpan = ((e) => {
		e.preventDefault();

		if (this.state.dt.jenis_barang_bangunan) {
			this.setState({ loadingPreview: true })

			let bodyData = this.state.dt
			bodyData = {
				...bodyData,
				jenis_barang_bangunan: bodyData.jenis_barang_bangunan.value,
				tanggal_penghapusan: dateFormat(bodyData.tanggal_penghapusan, "yyyy-mm-dd"),
				keterangan: document.getElementById("keterangan").value,
			}

			let psn = "";
			let resstat = 204;
			let metode = "create";
			if (bodyData.uuid === "") {
				psn = "tambah";
				resstat = 201;
				bodyData.uuid = null;
			} else {
				psn = "ubah";
				resstat = 200;
				metode = "update";
			}

			console.log(bodyData);

			Post('inventaris-desa/' + metode, bodyData.uuid, bodyData, res => {
				// console.log(res);
				if (res.status === resstat) {
					this.setState({
						loadingPreview: false,
						show: true,
						basicType: "success",
						basicTitle: "Data Inventaris " + JENIS_DESA,
						pesanAlert: "Berhasil " + psn + " Data"
					});

					document.getElementById('form-data').reset()
					this.fetch();
					this.setState({
						dt: frmDex,
						status: {
							...this.state.status,
							form: false
						}
					})
				} else {
					this.setState({
						loadingPreview: false,
						show: true,
						basicType: "danger",
						basicTitle: "Data Inventaris " + JENIS_DESA,
						pesanAlert: "Gagal " + psn + " Data"
					});
				}
			})

		} else {
			this.setState({
				show: true,
				basicType: "warning",
				basicTitle: "Data Inventaris " + JENIS_DESA,
				pesanAlert: "Pilih Jenis Barang / Bangunan"
			});
		}



	});
	// ========================================================================

	bukaForm = () => {
		this.setState({
			status: {
				...this.state.status,
				form: true,
			},
		})
		this.forceUpdate();
	};

	tutupForm = () => {
		this.setState({
			formDisposisi: false,
			status: {
				...this.state.status,
				form: false,
			},
		})

		this.forceUpdate();
	};

	ubahData = data => {
		this.setState({
			judul: "Ubah Data Inventaris " + JENIS_DESA,
			editMode: true
		})

		if (data) {
			this.setState({
				tmpImages: [],
				dt: {
					...this.state.dt,
					uuid: data.uuid,
					jenis_barang_bangunan: {
						value: data.jenis_barang_bangunan,
						label: data.jenis_barang_bangunan,
					},
					tanggal_penghapusan: new Date(data.tanggal_penghapusan),
					keterangan: data.keterangan,

					tahun: data.tahun,
					dibeli_sendiri: data.dibeli_sendiri,
					pemerintah: data.pemerintah,
					provinsi: data.provinsi,
					kab_kota: data.kab_kota,
					sumbangan: data.sumbangan,
					keadaan_baik_awal_tahun: data.keadaan_baik_awal_tahun,
					keadaan_rusak_awal_tahun: data.keadaan_rusak_awal_tahun,
					penghapusan_rusak: data.penghapusan_rusak,
					penghapusan_dijual: data.penghapusan_dijual,
					penghapusan_disumbangkan: data.penghapusan_disumbangkan,
					keadaan_baik_akhir_tahun: data.keadaan_baik_akhir_tahun,
					keadaan_rusak_akhir_tahun: data.keadaan_rusak_akhir_tahun,
				},
				status: {
					...this.state.status,
					form: true
				}
			})
		}
	}

	cariData = (e) => {
		if (e.key === 'Enter') {
			let txt = e.target.value
			this.setState({
				textCari: txt.trim(),
				loading: true
			});
			setTimeout(
				function () {
					this.fetch();
				}.bind(this),
				500
			);
		}
	};

	downloadSurat = () => {
		let token = sessionStorage.getItem("access_token")
			? sessionStorage.getItem("access_token")
			: "public";

		fetch(API_URL + 'inventaris-desa/cetak', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/pdf',
				'Authorization': 'Bearer ' + token,
			},
		})
			// .then((response) => response.blob())
			.then((response) => {
				if (response.status == 200) {
					return response.blob()
				}
				this.setState({
					loading: false,
					show: true,
					basicType: 'danger',
					basicTitle: 'Data Inventaris ' + JENIS_DESA,
					pesanAlert: 'Gagal cetak surat'
				});
				throw new Error('Something went wrong');
			})
			.then((blob) => {
				// Create blob link to download
				const url = window.URL.createObjectURL(
					new Blob([blob]),
				);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute(
					'download',
					`Inventaris dan Kekayaan ${JENIS_DESA}.pdf`,
				);

				// Append to html link element page
				document.body.appendChild(link);

				// Start download
				link.click();

				// Clean up and remove the link
				link.parentNode.removeChild(link);
				this.setState({
					loading: false,
				})
			})
			.catch((e) => {
				// console.log(e);
			})
			;
	}

	componentDidMount() {
		this.fetch()
		console.log(this.state.dt);
	}

	render() {
		var data = this.state.data;

		const columns = [
			{
				dataField: "no",
				text: "No",
				isDummyField: true,
				csvExport: false,
				headerAlign: 'center',
				align: 'center',
				formatter: (key, obj, index) => {
					let current_pagenum = this.state.pagination.current_page;
					let total_records_per_page = this.state.pagination.per_page;
					let row_index = (index + 1);
					let serial_num = ((total_records_per_page * (current_pagenum - 1)) + row_index);
					return serial_num;
				}
			},
			{
				dataField: 'jenis_barang_bangunan',
				text: 'JENIS BARANG / BANGUNAN',
				headerAlign: 'center',
				align: 'center',
				sort: false
			},
			// {
			// 	dataField: 'dibeli_sendiri',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	text: JENIS_DESA,
			// 	sort: false
			// },
			// {
			// 	dataField: 'pemerintah',
			// 	text: 'Pemerintah',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'provinsi',
			// 	text: 'Provinsi',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'kab_kota',
			// 	text: 'Kab/Kota',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'sumbangan',
			// 	text: 'Sumbangan',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'keadaan_baik_awal_tahun',
			// 	text: 'Baik Awal Tahun',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'keadaan_rusak_awal_tahun',
			// 	text: 'Rusak Awal Tahun',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'penghapusan_rusak',
			// 	text: 'Penghapusan Rusak',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'penghapusan_dijual',
			// 	text: 'Penghapusan Dijual',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'penghapusan_disumbangkan',
			// 	text: 'Penghapusan Disumbangkan',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'tanggal_penghapusan',
			// 	text: 'Tgl. Penghapusan',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			{
				dataField: 'keadaan_baik_akhir_tahun',
				text: 'Baik Akhir Tahun',
				headerAlign: 'center',
				align: 'center',
				sort: false
			},
			{
				dataField: 'keadaan_rusak_akhir_tahun',
				text: 'Rusak Akhir Tahun',
				headerAlign: 'center',
				align: 'center',
				sort: false
			},
			{
				dataField: 'keterangan',
				text: 'KET.',
				headerAlign: 'center',
				align: 'center',
				sort: false
			},
			{
				dataField: 'aksi',
				text: 'Aksi',
				headerAlign: 'center',
				align: 'center',
				formatter: function (cell, row) {
					return (
						<div style={{ minWidth: "61px" }}>
							<Button
								size="xs"
								color="success"
								className="btn-icon mr-2"
								onClick={() => this.ubahData(row)}
							// disabled={btnAksi}
							>
								<i className="fa fa-pencil"></i>
							</Button>{" "}
							<Button
								size="xs"
								color="info"
								className="btn-icon mr-2"
								onClick={() => {
									this.setState({
										detailPreview: true,
										detailData: row
									})
								}}
							>
								<i className="fa fa-eye"></i>
							</Button>{" "}
							<Button
								size="xs"
								color="danger"
								className="btn-icon"
								onClick={() => {
									this.setState({
										alert: (
											<SweetAlert
												showCancel
												confirmBtnText="Hapus"
												confirmBtnBsStyle="danger"
												cancelBtnBsStyle="success"
												type="danger"
												title="Yakin ingin hapus data ?"
												onCancel={this.hideAlert}
												onConfirm={() => {
													Delete('inventaris-desa/delete', row.uuid, (res) => {
														if (res === 200) {
															this.setState({
																show: true,
																basicType: 'success',
																basicTitle: 'Data Inventaris ' + JENIS_DESA,
																pesanAlert: 'Berhasil hapus data'
															});
															this.fetch()
														} else {
															this.setState({
																show: true,
																basicType: 'danger',
																basicTitle: 'Data Inventaris ' + JENIS_DESA,
																pesanAlert: 'Gagal hapus data'
															});
														}
														this.setState({ alert: null })
													})
												}}
											>
												Proses ini tidak dapat dibatalkan!
											</SweetAlert>
										)
									});
								}}
								disabled={this.state.status.btnAksi}
							>
								<i className="fa fa-trash"></i>
							</Button>
						</div>
					)
				}.bind(this)
			}
		]

		return (
			<div>
				{/* <Breadcrumb title="Data Peraturan Desa" parent="Admin" /> */}
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>

				<SweetAlert
					show={this.state.loadingPreview}
					showCancel={false}
					showConfirm={false}
				>
					<div align="center">
						{/* <h5 className="modal-title mb-3" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5> */}
						<img
							alt="loading"
							src={require("../../../assets/images/tes-loading.gif")}
							style={{
								borderRadius: "10px",
								width: '150px'
							}}
						/>
					</div>
				</SweetAlert>

				{this.state.alert}

				<div className="container-fluid">
					<div className="row">
						<div className="col-sm-12">
							<div className="card mb-0">
								<div className="card-header">
									<div className="row">
										<div className="col-sm-6 text-left">
											<Button
												size="sm"
												color="default"
												style={{ backgroundColor: '#FFC312' }}
												onClick={this.props.history.goBack}
											>
												<i className="fa fa-arrow-left"></i> Kembali
											</Button>
										</div>
										<div className="col-sm-6 text-right">
											<Button
												size="sm"
												color="info"
												className="btn-icon mr-2"
												onClick={() => {
													this.setState({ loading: true })
													this.downloadSurat()
												}}
											>
												Cetak
											</Button>{" "}
											<Button
												size="sm"
												color="success"
												className="btn-square"
												onClick={() => {
													this.setState({
														judul: 'Tambah Inventaris di ' + JENIS_DESA,
														dt: frmDex,
														tmpImages: ['kosong'],
														editMode: false,
														currentLocation: this.state.curStaticLocation
													});
													// document.getElementById('form-data').reset()
													this.bukaForm();
												}}
											>
												Tambah Data
											</Button>
										</div>
									</div>
								</div>

								<div className="card-body datatable-react custom-font-sm">
									{/* <div className="row">
										<div className="col-md-12"> */}
									{this.state.loading ? (
										<div className="row">
											<div className="col-sm-12" align="center">
												<img
													alt="loading"
													src={require("../../../assets/images/tes-loading.gif")}
													style={{
														borderRadius: "10px",
														width: '100px'
													}} />
											</div>
										</div>
									) : (
										<div className='row'>
											<div className="col-md-5 text-right">
												<input
													type="text"
													className="form-control"
													style={{ marginBottom: '15px' }}
													id="cariTable"
													placeholder="Cari berdasarkan jenis barang / bangunan"
													defaultValue={this.state.textCari}
													onChange={(e) => {
														this.setState({ textCari: e.target.value })
													}}
													onKeyPress={this.cariData}
												/>
												<div className="clearBtnSearch" style={{ display: this.state.textCari !== '' ? 'inline' : '' }}>
													<span className='fa fa-close' style={{ fontSize: '1.3em', cursor: 'pointer' }} onClick={() => {
														this.setState({
															textCari: '',
															loading: true
														});
														setTimeout(
															function () {
																this.fetch();
															}.bind(this),
															500
														);
														document.getElementById('cariTable').value = ''
													}} ></span>
												</div>
											</div>
											<div className="col-md-7" style={{ marginBottom: '15px' }}>
												<Button
													size="sm"
													color="info"
													className="btn-square"
													onClick={() => {
														this.setState({
															textCari: document.getElementById("cariTable").value,
															loading: true
														});
														setTimeout(
															function () {
																this.fetch();
															}.bind(this),
															500
														);
													}}
												>
													<i className="fa fa-search"></i>
												</Button>
											</div>
											{data.length > 0 ? (
												<>
													<div className="col-md-12">
														<BootstrapTable
															keyField="id"
															data={data}
															columns={columns}
														/>
														<div className="pull-right text-white">
															{this.state.awal}
															{this.state.sebelum}
															{this.state.hal.map(dt => {
																return dt;
															})}
															{this.state.setelah}
															{this.state.akhir}
														</div>
													</div>
												</>
											) : (
												<div className="col-md-12">
													<h6 className="text-center mb-2 mt-2">Data tidak ditemukan</h6>
												</div>
											)}
										</div>
									)}
									{/* </div>
									</div> */}
								</div>
							</div>
						</div>
					</div>
				</div>
				<br />
				<Modal
					open={this.state.detailPreview ? true : false}
					onClose={() => {
						this.setState({ detailPreview: false })
					}}
					closeOnEsc={true}
					closeOnOverlayClick={true}
					styles={{ modal: { width: '50%', maxWidth: 'unset' } }}
				>
					<div className="modal-header">
						<h5 className="modal-title" style={{ fontWeight: 'bold' }}>Detail Data Inventaris</h5>
					</div>
					<div className="modal-body">
						<div className="row">
							<div className="col-md-12">
								{this.state.detailData ? (
									<>
										<div className="table-responsive">
											<table className='detail-dokumen-administrasi'>
												<tbody>
													<tr>
														<th width="280">Jenis Barang / Bangunan</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.jenis_barang_bangunan}</span></td>
													</tr>
													<tr>
														<th width="280">Tahun</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.tahun}</span></td>
													</tr>

													<tr style={{ borderTop: "1px solid black" }}>
														<th><b>Asal Barang / Bangunan</b></th>
														<th></th>
														<th></th>
													</tr>
													<tr>
														<th><b>a. Dibeli Sendiri</b></th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.dibeli_sendiri}</span></td>
													</tr>
													<tr>
														<th><b>b. Bantuan</b></th>
														<th></th>
														<th></th>
													</tr>
													<tr>
														<th className='pl-4'>Pemerintah</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.pemerintah}</span></td>
													</tr>
													<tr>
														<th className='pl-4'>Provinsi</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.provinsi}</span></td>
													</tr>
													<tr>
														<th className='pl-4'>Kabupaten/ Kota</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.kab_kota}</span></td>
													</tr>
													<tr>
														<th><b>c. Sumbangan</b></th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.sumbangan}</span></td>
													</tr>

													<tr style={{ borderTop: "1px solid black" }}>
														<th><b>Keadaan Barang Awal Tahun</b></th>
														<th></th>
														<th></th>
													</tr>
													<tr>
														<th>Baik</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.keadaan_baik_awal_tahun}</span></td>
													</tr>
													<tr>
														<th>Rusak</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.keadaan_rusak_awal_tahun}</span></td>
													</tr>

													<tr style={{ borderTop: "1px solid black" }}>
														<th><b>Keadaan Barang Akhir Tahun</b></th>
														<th></th>
														<th></th>
													</tr>
													<tr>
														<th>Baik</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.keadaan_baik_akhir_tahun}</span></td>
													</tr>
													<tr>
														<th>Rusak</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.keadaan_rusak_akhir_tahun}</span></td>
													</tr>

													<tr style={{ borderTop: "1px solid black" }}>
														<th><b>Penghapusan Barang / Bangunan</b></th>
														<th></th>
														<th></th>
													</tr>
													<tr>
														<th>Rusak</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.penghapusan_rusak}</span></td>
													</tr>
													<tr>
														<th>Dijual</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.penghapusan_dijual}</span></td>
													</tr>
													<tr>
														<th>Disumbangkan</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.penghapusan_disumbangkan}</span></td>
													</tr>
													<tr>
														<th>Tanggal Penghapusan</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.tanggal_penghapusan}</span></td>
													</tr>

													<tr style={{ borderTop: "1px solid black" }}>
														<th>Keterangan tambahan</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.keterangan}</span></td>
													</tr>

												</tbody>
											</table>
										</div>
									</>
								) : ''}
							</div>
						</div>
					</div>
				</Modal>
				<Modal
					open={this.state.status.form}
					onClose={this.tutupForm}
					closeOnEsc={false}
					closeOnOverlayClick={false}
					styles={{ modal: { width: '60%', maxWidth: "unset" } }}
				>
					<Form id="form-data" className="theme-form" onSubmit={(e) => { this.simpan(e) }}>
						<input className="form-control" id="uuid" type="hidden" defaultValue={this.state.dt.uuid} value={this.state.dt.uuid} />
						<div className="modal-header">
							<h5 className="modal-title" style={{ fontWeight: 'bold' }}>{this.state.judul}</h5>
						</div>
						<div className="modal-body">
							{/* <input
								className="form-control"
								id="uuid"
								type="hidden"
								placeholder="UUID"
								defaultValue={this.state.dt.uuid}
								value={this.state.dt.uuid}
							/> */}
							{/* <FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
								>
									Jenis Barang / Bangunan
								</Label>
								<Col sm="6">
									<ReactSelect
										inputId="jenis_barang_bangunan"
										classNamePrefix="select"
										// isClearable
										onChange={e => {
											this.setState({ dt: {
												...this.state.dt,
												jenis_barang_bangunan: e
											} })
										}}
										defaultValue={this.state.dt.jenis_barang_bangunan}
										value={this.state.dt.jenis_barang_bangunan}
										options={[
											{
												value: 'Barang',
												label: 'Barang',
											},
											{
												value: 'Bangunan',
												label: 'Bangunan',
											},
										]}
										placeholder={"Pilih Jenis Barang / Bangunan "}
									/>
								</Col>
								<Col sm="3">
									<input
										className="form-control"
										id="tahun"
										type="number"
										min={0}
										max={new Date().getFullYear()}
										placeholder={"Masukkan jumlah barang / bangunan yang dibiayai sendiri oleh " +JENIS_DESA}
										defaultValue={this.state.dt.tahun}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													tahun: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
							</FormGroup> */}

							<div className="form-row">
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Jenis Barang / Bangunan</Label>
									<ReactSelect
										inputId="jenis_barang_bangunan"
										classNamePrefix="select"
										// isClearable
										onChange={e => {
											this.setState({
												dt: {
													...this.state.dt,
													jenis_barang_bangunan: e
												}
											})
										}}
										defaultValue={this.state.dt.jenis_barang_bangunan}
										value={this.state.dt.jenis_barang_bangunan}
										options={[
											{
												value: 'Barang',
												label: 'Barang',
											},
											{
												value: 'Bangunan',
												label: 'Bangunan',
											},
										]}
										placeholder={"Pilih Jenis Barang / Bangunan "}
									/>
								</Col>
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Tahun</Label>
									<input
										className="form-control"
										id="tahun"
										type="number"
										min={0}
										max={new Date().getFullYear()}
										placeholder={"Masukkan jumlah barang / bangunan yang dibiayai sendiri oleh " + JENIS_DESA}
										defaultValue={this.state.dt.tahun}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													tahun: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
							</div>

							<hr />

							<FormGroup className="row ml-0 mr-0 mb-2" style={{ backgroundColor: '#666666' }}>
								<Label
									className="col-sm-12 col-form-label text-white"
								>
									<b>ASAL BARANG / BANGUNAN</b>
								</Label>
							</FormGroup>
							<div className="form-row mb-0">
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Pemerintah</Label>
									<input
										className="form-control"
										id="pemerintah"
										type="number"
										min={0}
										placeholder={"Masukkan jumlah barang / bangunan yang dibiayai oleh Pemerintah"}
										defaultValue={this.state.dt.pemerintah}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													pemerintah: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Provinsi</Label>
									<input
										className="form-control"
										id="provinsi"
										type="number"
										min={0}
										placeholder={"Masukkan jumlah barang / bangunan yang dibiayai oleh Pemerintah Provinsi"}
										defaultValue={this.state.dt.provinsi}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													provinsi: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Kabupaten / Kota</Label>
									<input
										className="form-control"
										id="kab_kota"
										type="number"
										min={0}
										placeholder={"Masukkan jumlah barang / bangunan yang dibiayai oleh Pemerintah Kota / Kabupaten"}
										defaultValue={this.state.dt.kab_kota}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													kab_kota: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Dibeli Sendiri</Label>
									<input
										className="form-control"
										id="dibeli_sendiri"
										type="number"
										min={0}
										placeholder={"Masukkan jumlah barang / bangunan yang dibiayai sendiri oleh " + JENIS_DESA}
										defaultValue={this.state.dt.dibeli_sendiri}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													dibeli_sendiri: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Sumbangan</Label>
									<input
										className="form-control"
										id="sumbangan"
										type="number"
										min={0}
										placeholder={"Masukkan jumlah barang / bangunan yang dibiayai sendiri oleh " + JENIS_DESA}
										defaultValue={this.state.dt.sumbangan}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													sumbangan: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
							</div>

							<hr />

							<FormGroup className="row ml-0 mr-0 mb-2" style={{ backgroundColor: '#666666' }}>
								<Label
									className="col-sm-12 col-form-label text-white"
								>
									<b>KEADAAN BARANG / BANGUNAN AWAL TAHUN</b>
								</Label>
							</FormGroup>
							<div className="form-row mb-4">
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Baik</Label>
									<input
										className="form-control"
										id="keadaan_baik_awal_tahun"
										type="number"
										min={0}
										placeholder={"Masukkan jumlah barang / bangunan yang dibiayai sendiri oleh " + JENIS_DESA}
										defaultValue={this.state.dt.keadaan_baik_awal_tahun}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													keadaan_baik_awal_tahun: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Rusak</Label>
									<input
										className="form-control"
										id="keadaan_rusak_awal_tahun"
										type="number"
										min={0}
										placeholder={"Masukkan jumlah barang / bangunan yang dibiayai sendiri oleh " + JENIS_DESA}
										defaultValue={this.state.dt.keadaan_rusak_awal_tahun}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													keadaan_rusak_awal_tahun: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
							</div>

							<hr />

							<FormGroup className="row ml-0 mr-0 mb-2" style={{ backgroundColor: '#666666' }}>
								<Label
									className="col-sm-12 col-form-label text-white"
								>
									<b>PENGHAPUSAN BARANG DAN BANGUNAN</b>
								</Label>
							</FormGroup>
							<div className="form-row mb-2">
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Rusak</Label>
									<input
										className="form-control"
										id="penghapusan_rusak"
										type="number"
										min={0}
										placeholder={"Jumlah barang / bangunan yang dihapus karena rusak"}
										defaultValue={this.state.dt.penghapusan_rusak}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													penghapusan_rusak: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Dijual</Label>
									<input
										className="form-control"
										id="penghapusan_dijual"
										type="number"
										min={0}
										placeholder={"Jumlah barang / bangunan yang dihapus karena dijual"}
										defaultValue={this.state.dt.penghapusan_dijual}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													penghapusan_dijual: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Disumbangkan</Label>
									<input
										className="form-control"
										id="penghapusan_disumbangkan"
										type="number"
										min={0}
										placeholder={"Jumlah barang / bangunan yang dihapus karena disumbangkan"}
										defaultValue={this.state.dt.penghapusan_disumbangkan}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													penghapusan_disumbangkan: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Tanggal Penghapusan</Label>
									<Datetime
										inputProps={{
											"data-testid": "tanggal_penghapusan",
											placeholder: 'Tanggal kesepakatan pemerintah desa dan BPD',
											required: true
										}}
										inputId="tanggal_penghapusan"
										name="tanggal_penghapusan"
										locale="id-ID"
										timeFormat={false}
										dateFormat="DD/MM/yyyy"
										closeOnTab={true}
										closeOnSelect={true}
										initialValue={this.state.dt.tanggal_penghapusan}
										value={this.state.dt.tanggal_penghapusan}
										onChange={e => {
											if (typeof e._isValid !== 'undefined') {
												let tgl = e.format('YYYY-MM-DD');
												this.setState({
													dt: {
														...this.state.dt,
														tanggal_penghapusan: new Date(tgl)
													}
												})
											}
										}}
									/>
								</Col>
							</div>

							<hr />

							<FormGroup className="row ml-0 mr-0 mb-2" style={{ backgroundColor: '#666666' }}>
								<Label
									className="col-sm-12 col-form-label text-white"
								>
									<b>KEADAAN BARANG / BANGUNAN AKHIR TAHUN</b>
								</Label>
							</FormGroup>
							<div className="form-row mb-4">
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Baik</Label>
									<input
										className="form-control"
										id="keadaan_baik_akhir_tahun"
										type="number"
										min={0}
										placeholder={"Masukkan jumlah barang / bangunan yang dibiayai sendiri oleh " + JENIS_DESA}
										defaultValue={this.state.dt.keadaan_baik_akhir_tahun}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													keadaan_baik_akhir_tahun: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Rusak</Label>
									<input
										className="form-control"
										id="keadaan_rusak_akhir_tahun"
										type="number"
										min={0}
										placeholder={"Masukkan jumlah barang / bangunan yang dibiayai sendiri oleh " + JENIS_DESA}
										defaultValue={this.state.dt.keadaan_rusak_akhir_tahun}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													keadaan_rusak_akhir_tahun: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
							</div>

							<hr />

							{/* <FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="nik"
								>
									Keterangan
								</Label>
								<Col sm="9">
									<textarea className='form-control' name="keterangan" id="keterangan" cols="30" placeholder='Diisi dengan catatan-catatan lain yang dianggap perlu.' defaultValue={this.state.dt.keterangan} rows="3" required />
								</Col>
							</FormGroup> */}

							<div className="form-row mb-4">
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Keterangan tambahan</Label>
									<textarea className='form-control' name="keterangan" id="keterangan" cols="30" placeholder='Diisi dengan catatan-catatan lain yang dianggap perlu.' defaultValue={this.state.dt.keterangan} rows="3" />
								</Col>
							</div>

						</div>
						<div className="modal-footer">
							<button
								type="button"
								className="btn btn-warning"
								disabled={this.state.status.btnForm}
								onClick={this.tutupForm}
							>
								Tutup
							</button>
							<button type="submit" className="btn btn-success" disabled={this.state.status.btnForm}>
								Simpan
							</button>
						</div>
					</Form>
				</Modal>
			</div>
		);
	}
}

export default MenuA3;
